import React, { PureComponent } from "react";
import AuditTrailCeo from "./ceo";
import AuditTrailProductDevelopment from "./product-development";
import AuditTrailProductMarketing from "./product-marketing";
import AuditTrailOperations from "./operations";
import AuditTrailFinance from "./finance";
import Auth from "../../routes/Auth";
import { getRequest, batchRequest } from "../../api/ApiService";
import moment from "moment";
import _ from "lodash";
import { Link } from "react-router";

const numberWithCommas = x => {
  return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
};

const replaceAll = (str, replacements) => {
  let result = str;

  Object.keys(replacements).forEach(search => {
    const replacement = replacements[search];
    result = result.split(search).join(replacement);
  });

  return result;
};

const jsonDecode = str => {
  return JSON.parse(
    replaceAll(str, {
      "{u'": '{"',
      ", u'": ', "',
      ": u'": ': "',
      "':": '":',
      "',": '",',
      "'}": '"}'
    })
  );
};

class AuditTrail extends PureComponent {
  constructor(props) {
    super(props);

    const isInstructor = Auth.getPosition() === "Instructor";

    this.state = {
      currentRound: props.currentRound,
      roundInUrl: props.roundInRound,
      rounds: props.rounds,
      histories: [],
      users: [],
      players: [],
      team_machines: [],
      static_machines: [],
      products: {},
      roundDecisions: {},
      isInstructor: isInstructor
    };
  }

  componentWillMount() {
    this.fetchData();
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.roundInUrl !== nextProps.roundInUrl ||
      this.state.currentRound !== nextProps.currentRound ||
      (this.state.rounds.length === 0 && nextProps.rounds.length !== 0)
    ) {
      this.setState(
        {
          roundInUrl: nextProps.roundInUrl,
          currentRound: nextProps.currentRound,
          rounds: nextProps.rounds
        },
        () => {
          this.fetchData();
        }
      );
    }
  }

  get activeRound() {
    const { currentRound, roundInUrl } = this.state;
    let activeRound = currentRound;

    if (
      roundInUrl !== null &&
      roundInUrl !== undefined &&
      roundInUrl !== currentRound
    ) {
      activeRound = roundInUrl;
    }

    if (!activeRound) {
      activeRound = 0;
    }

    return activeRound;
  }

  fetchData = () => {
    const { isInstructor } = this.state;
    const team_id = Auth.getTeamId();

    this.getAuditTrailRequest(isInstructor, team_id)
      .then(res => {
        let histories = [];

        res.forEach(r => {
          if (r.statusCode === 200) {
            histories = histories.concat(r.body);
          }
        });

        this.setState({
          histories
        });
      })
      .catch(err => { });
    this.getUsersRequest()
      .then(res => {
        this.setState({
          users: res.body
        });
      })
      .catch(err => { });
    this.getProductsRequest(isInstructor, team_id)
      .then(res => {
        let products = {};

        res.body.forEach(product => {
          products[product.id] = product.name;
        });

        this.setState({
          products
        });
      })
      .catch(err => { });
    this.getTeamMachinesRequest(isInstructor, team_id)
      .then(res => {
        this.setState({
          team_machines: res.body
        });
      })
      .catch(err => { });
    this.getStaticMachinesRequest()
      .then(res => {
        this.setState({
          static_machines: res.body
        });
      })
      .catch(err => { });
    this.getRoundDecisions(isInstructor, team_id)
      .then(res => {
        this.setState({
          roundDecisions: res.body
        });
      })
      .catch(err => { });
    this.getPlayers(isInstructor, team_id).then(res => {
      this.setState({
        players: res.body
      });
    });
  };

  getStaticMachinesRequest = () => {
    return getRequest(`${process.env.REACT_APP_API_URL}static/machines/`);
  };

  getTeamMachinesRequest = (isInstructor, team_id) => {
    return getRequest(
      isInstructor
        ? `${process.env.REACT_APP_API_URL}team/machines/?team_id=${team_id}`
        : `${process.env.REACT_APP_API_URL}team/machines/`
    );
  };

  getUsersRequest = () => {
    return getRequest(`${process.env.REACT_APP_API_URL}users/`);
  };

  getPlayers = (isInstructor, team_id) => {
    return getRequest(
      isInstructor
        ? `${process.env.REACT_APP_API_URL}team/players/?team=${team_id}`
        : `${process.env.REACT_APP_API_URL}team/players/`
    );
  };

  getRounds = () => {
    return getRequest(`${process.env.REACT_APP_API_URL}game/rounds/`);
  };

  getProductsRequest = (isInstructor, team_id) => {
    return getRequest(
      isInstructor
        ? `${process.env.REACT_APP_API_URL}team/products/?round_lte=${this.activeRound}&team_id=${team_id}`
        : `${process.env.REACT_APP_API_URL}team/products/?round_lte=${this.activeRound}`
    );
  };

  getRoundDecisions = (isInstructor, team_id) => {
    if (isInstructor) {
      return this.getRounds()
        .then(res => {
          const rounds = res.body;
          const round = rounds.find(i => i.number === this.activeRound);
          const round_id = round ? round.id : 0;
          return getRequest(
            `${process.env.REACT_APP_API_URL}teams/${team_id}/round_decisions/${round_id}`
          );
        })
        .catch(err => { });
    } else {
      const { rounds } = this.props;
      const round = rounds.find(i => i.number === this.activeRound);
      const round_id = round ? round.id : 0;
      return getRequest(
        `${process.env.REACT_APP_API_URL}teams/${team_id}/round_decisions/${round_id}`
      );
    }
  };

  getAuditTrailRequest = (isInstructor, team_id) => {
    const game_id = Auth.getGameId();
    let requests = [];

    for (var i = 1; i <= this.activeRound; i++) {
      requests.push(
        isInstructor
          ? `${process.env.REACT_APP_API_URL}games/${game_id}/journal/?round_number=${i}&team_id=${team_id}`
          : `${process.env.REACT_APP_API_URL}games/${game_id}/journal/?round_number=${i}`
      );
    }

    return batchRequest(requests);
  };

  get ceoHistories() {
    const { histories, users } = this.state;
    let data = [];
    histories
      .filter(
        i =>
          i.path.startsWith("/api/team/projections/") &&
          ((i.method === "POST" && i.status_code === 201) ||
            (i.method === "PATCH" && i.status_code === 200))
      )
      .forEach(history => {
        const user = users.find(i => i.id === history.user);
        const timestamp = moment(history.requested_at);
        const base = {
          timestamp: timestamp.format("hh:mm:ss A MM/DD/YYYY"),
          unix: timestamp.unix(),
          first_name: user ? user.first_name : "",
          last_name: user ? user.last_name : "",
          submitted: "N/A",
          round: history.round_number,
          projection:
            history.response.target_round_number - history.round_number + 1
        };

        data.push({
          ...base,
          line_item: "Average Unit Costs",
          value: "$" + history.response.average_unit_costs.toFixed(2)
        });

        data.push({
          ...base,
          line_item: "Other Expenses (in millions)",
          value:
            "$" +
            (history.response.other_operating_costs / 1000000).toFixed(2) +
            "M"
        });

        data.push({
          ...base,
          line_item: "Average Selling Price",
          value: "$" + history.response.average_selling_price.toFixed(2)
        });

        data.push({
          ...base,
          line_item: "Units (in millions)",
          value: (history.response.units_sold / 1000000).toFixed(3) + "M"
        });
      });

    let groupped = _.groupBy(
      data,
      item =>
        `${item.first_name}-${item.last_name}-${item.round}-${item.line_item}`
    );
    let result = [];
    for (var key in groupped) {
      const chunks = _.chunk(groupped[key], 3);
      chunks.forEach(chunk => {
        let item = {
          line_item: chunk[0].line_item,
          round: chunk[0].round,
          submitted: chunk[0].submitted,
          timestamp: chunk[0].timestamp,
          unix: chunk[0].unix,
          first_name: chunk[0].first_name,
          last_name: chunk[0].last_name
        };

        chunk.forEach(subchunk => {
          const key = `projection${subchunk.projection}`;
          item[key] = subchunk.value;
        });

        const nums = [1, 2, 3];
        nums.forEach(num => {
          const num_key = `projection${num}`;
          if (!(num_key in item)) {
            if (item.line_item === "Average Unit Costs") {
              item[num_key] = "$0.00";
            } else if (item.line_item === "Other Expenses (in millions)") {
              item[num_key] = "$0.00M";
            } else if (item.line_item === "Average Selling Price") {
              item[num_key] = "$0.00";
            } else if (item.line_item === "Units (in millions)") {
              item[num_key] = "0.000M";
            }
          }
        });

        result.push(item);
      });
    }

    return _.sortBy(result, item => item.unix).filter(
      i => i.round === this.activeRound
    );
  }

  get pdHistories() {
    const { histories, users } = this.state;
    let products = { ...this.state.products };

    return histories
      .filter(
        i =>
          (i.path.startsWith("/api/team/products/") &&
            ((i.method === "POST" && i.status_code === 201) ||
              (i.method === "PATCH" && i.status_code === 200) ||
              (i.method === "DELETE" && i.status_code === 204))) ||
          i.path === "/api/teams/submit_development/"
      )
      .map(history => {
        if (history.path === "/api/teams/submit_development/") {
          const user = users.find(i => i.id === history.user);
          const timestamp = moment(history.requested_at);

          return {
            timestamp: timestamp.format("hh:mm:ss A MM/DD/YYYY"),
            first_name: user ? user.first_name : "",
            last_name: user ? user.last_name : "",
            productname: "Submission",
            resolution: "",
            sensitivity: "",
            power: "",
            temprange: "",
            submitted:
              history.response &&
                history.response.success &&
                history.response.success === true
                ? "Success"
                : "Fail",
            round: history.round_number
          };
        } else {
          const user = users.find(i => i.id === history.user);
          const timestamp = moment(history.requested_at);
          let product_name = "";
          if (history.method === "POST") {
            const data = jsonDecode(history.data);
            products[history.response.id] = data.name;
            product_name = products[history.response.id];
          } else if (history.method === "PATCH") {
            if (history.response.id in products) {
              product_name = products[history.response.id];
            }
          } else if (history.method === "DELETE") {
            const matches = history.path.match(
              /\/api\/team\/products\/(\d+)\//i
            );
            const product_id = parseInt(matches[1], 10);

            if (product_id in products) {
              product_name = `${products[product_id]} Removed`;
            }
          }

          return {
            timestamp: timestamp.format("hh:mm:ss A MM/DD/YYYY"),
            first_name: user ? user.first_name : "",
            last_name: user ? user.last_name : "",
            productname: product_name,
            resolution:
              history.method !== "DELETE"
                ? history.response.pixels_rank
                : "N/A",
            sensitivity:
              history.method !== "DELETE"
                ? history.response.sensitivity_rank
                : "N/A",
            power:
              history.method !== "DELETE" ? history.response.power_rank : "N/A",
            temprange:
              history.method !== "DELETE"
                ? history.response.temp_range_rank
                : "N/A",
            submitted: "",
            round: history.round_number
          };
        }
      })
      .filter(i => i.round === this.activeRound);
  }

  get pmHistories() {
    const { roundDecisions, users, players, products, histories } = this.state;

    const result = roundDecisions.PM
      ? roundDecisions.PM.map(history => {
        const player = players.find(i => i.id === history.player_id);
        const timestamp = moment(history.updated_at);

        return {
          timestamp: timestamp.format("hh:mm:ss A MM/DD/YYYY"),
          first_name: player && player.user ? player.user.first_name : "",
          last_name: player && player.user ? player.user.last_name : "",
          product_name:
            history.product_id && products[history.product_id]
              ? products[history.product_id]
              : "",
          price:
            history.model === "PriceForecast"
              ? "$" + history.price.toFixed(2)
              : "",
          traditional:
            history.model === "Promo" && history.client_id === 1
              ? "$" + numberWithCommas(history.spend)
              : "",
          digital:
            history.model === "Promo" && history.client_id === 2
              ? "$" + numberWithCommas(history.spend)
              : "",
          placement:
            history.model === "Sales"
              ? history.client_id === 3
                ? "Direct Sales"
                : "Distributor"
              : "",
          terms:
            history.model === "AccountReceivableTerm" ? history.days : "",
          submitted: ""
        };
      })
      : [];

    histories
      .filter(
        i =>
          i.path === "/api/teams/submit_marketing/" &&
          i.round_number === this.activeRound
      )
      .forEach(history => {
        const user = users.find(i => i.id === history.user);
        const timestamp = moment(history.requested_at);

        result.push({
          timestamp: timestamp.format("hh:mm:ss A MM/DD/YYYY"),
          first_name: user ? user.first_name : "",
          last_name: user ? user.last_name : "",
          product_name: "Submission",
          price: "",
          traditional: "",
          digital: "",
          placement: "",
          terms: "",
          submitted:
            history.response &&
              history.response.success &&
              history.response.success === true
              ? "Success"
              : "Fail"
        });
      });

    return result;
  }

  get opHistories() {
    const { histories, users, team_machines, static_machines } = this.state;

    return histories
      .filter(
        i =>
          i.path === "/api/team/machines/" ||
          i.path === "/api/team/product_manufactures/" ||
          /\/api\/team\/machines\/\d+\/sell\//i.test(i.path) ||
          (/\/api\/team\/product_manufactures\/\d+\//i.test(i.path) &&
            i.method === "DELETE") ||
          i.path === "/api/teams/submit_operations/"
      )
      .map(history => {
        if (history.path === "/api/team/product_manufactures/") {
          const user = users.find(i => i.id === history.user);
          const team_machine = team_machines.find(
            i => i.id === history.response.machine
          );
          const timestamp = moment(history.requested_at);
          return {
            timestamp: timestamp.format("hh:mm:ss A MM/DD/YYYY"),
            first_name: user ? user.first_name : "",
            last_name: user ? user.last_name : "",
            name: "Production",
            units: numberWithCommas(history.response.units_produced),
            machine_used: team_machine ? `Machine${team_machine.machine}` : "",
            type: "",
            value: "",
            submitted: "",
            round: history.round_number
          };
        }

        if (history.path === "/api/team/machines/") {
          const user = users.find(i => i.id === history.user);
          const timestamp = moment(history.requested_at);
          const static_machine = static_machines.find(
            i => i.id === history.response.machine
          );
          return {
            timestamp: timestamp.format("hh:mm:ss A MM/DD/YYYY"),
            first_name: user ? user.first_name : "",
            last_name: user ? user.last_name : "",
            name: "Machine",
            units: "",
            machine_used: "Bought",
            type: `Machine${history.response.machine}`,
            value: static_machine
              ? "$" + numberWithCommas(static_machine.costs)
              : "",
            submitted: "",
            round: history.round_number
          };
        }

        if (
          /\/api\/team\/machines\/\d+\/sell\//i.test(history.path) &&
          history.method === "POST"
        ) {
          const user = users.find(i => i.id === history.user);
          const timestamp = moment(history.requested_at);
          const matches = history.path.match(
            /\/api\/team\/machines\/(\d+)\/sell\//i
          );
          const machineId = parseInt(matches[1], 10);

          return {
            timestamp: timestamp.format("hh:mm:ss A MM/DD/YYYY"),
            first_name: user ? user.first_name : "",
            last_name: user ? user.last_name : "",
            name: "Machine",
            units: "",
            machine_used: "Sold",
            type: machineId,
            value: "",
            submitted: "",
            round: history.round_number
          };
        }

        if (
          /\/api\/team\/product_manufactures\/\d+\//i.test(history.path) &&
          history.method === "DELETE"
        ) {
          const user = users.find(i => i.id === history.user);
          const timestamp = moment(history.requested_at);
          return {
            timestamp: timestamp.format("hh:mm:ss A MM/DD/YYYY"),
            first_name: user ? user.first_name : "",
            last_name: user ? user.last_name : "",
            name: "Production Deleted",
            units: "",
            machine_used: "",
            type: "",
            value: "",
            submitted: "",
            round: history.round_number
          };
        }

        if (history.path === "/api/teams/submit_operations/") {
          const user = users.find(i => i.id === history.user);
          const timestamp = moment(history.requested_at);
          return {
            timestamp: timestamp.format("hh:mm:ss A MM/DD/YYYY"),
            first_name: user ? user.first_name : "",
            last_name: user ? user.last_name : "",
            name: "Submission",
            units: "",
            machine_used: "",
            type: "",
            value: "",
            submitted:
              history.response &&
                history.response.success &&
                history.response.success === true
                ? "Success"
                : "Fail",
            round: history.round_number
          };
        }

        return {};
      })
      .filter(i => i.round === this.activeRound);
  }

  get fnHistories() {
    const { roundDecisions, players } = this.state;

    return roundDecisions.FI
      ? roundDecisions.FI.map(history => {
        const player = players.find(i => i.id === history.player_id);
        const timestamp = moment(history.updated_at);
        const descriptions = {
          TeamEquity: "Issuing Equity",
          TeamDebt: "Issuing Debt",
          DebtRepayment: "Repaying Debt",
          StockRepurchased: "Stock Buybacks",
          DividendsPayment: "Dividend Payment"
        };
        const investor_names = {
          1: "Prudent Bank",
          2: "Mezz Capital",
          3: "Great White Financials"
        };

        let amount = "";
        if (history.model === "TeamEquity") {
          amount = history.capital;
        } else if (history.model === "StockRepurchased") {
          amount = history.shares;
        } else if (history.model === "DividendsPayment") {
          amount = history.payment;
        } else if (history.model === "TeamDebt") {
          amount = history.new_amount;
        } else if (history.model === "DebtRepayment") {
          amount = history.amount;
        }

        return {
          timestamp: timestamp.format("hh:mm:ss A MM/DD/YYYY"),
          first_name: player && player.user ? player.user.first_name : "",
          last_name: player && player.user ? player.user.last_name : "",
          category:
            history.model === "TeamEquity" || history.model === "TeamDebt"
              ? "Raising Capital"
              : "Returning Capital",
          description: descriptions[history.model],
          investor_name:
            history.model === "TeamDebt" || history.model === "DebtRepayment"
              ? investor_names[history.client_id]
              : "GBorGH Ventures",
          amount: amount !== "" ? "$" + numberWithCommas(amount) : ""
        };
      })
      : [];
  }

  render() {
    const { location, currentRound, roundInUrl } = this.props;
    const routes = location.pathname.split("/").filter(i => i !== "");
    const role = routes[0];
    let activeRound = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      activeRound = roundInUrl;
    }
    let page = null;

    if (role === "ceo") {
      page = <AuditTrailCeo histories={this.ceoHistories} />;
    }

    if (role === "pd") {
      page = <AuditTrailProductDevelopment histories={this.pdHistories} />;
    }

    if (role === "pm") {
      page = <AuditTrailProductMarketing histories={this.pmHistories} />;
    }

    if (role === "op") {
      page = <AuditTrailOperations histories={this.opHistories} />;
    }

    if (role === "fn") {
      page = <AuditTrailFinance histories={this.fnHistories} />;
    }

    return (
      <div className="dashboard">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            paddingTop: "30px"
          }}
        >
          <div className="team-reports-menu">
            <div
              style={{
                display: "flex",
                flexDirection: "column"
              }}
            >
              <Link
                to={`/ceo/audit-trail?round=${activeRound}`}
                className={role === "ceo" ? "active" : null}
                style={{ paddingLeft: "15px" }}
              >
                CEO
              </Link>
              <Link
                to={`/pd/audit-trail?round=${activeRound}`}
                className={role === "pd" ? "active" : null}
                style={{ paddingLeft: "15px" }}
              >
                Head of Product
              </Link>
              <Link
                to={`/pm/audit-trail?round=${activeRound}`}
                className={role === "pm" ? "active" : null}
                style={{ paddingLeft: "15px" }}
              >
                Head of Marketing
              </Link>
              <Link
                to={`/op/audit-trail?round=${activeRound}`}
                className={role === "op" ? "active" : null}
                style={{ paddingLeft: "15px" }}
              >
                Head of Operations
              </Link>
              <Link
                to={`/fn/audit-trail?round=${activeRound}`}
                className={role === "fn" ? "active" : null}
                style={{ paddingLeft: "15px" }}
              >
                Head of Finance
              </Link>
            </div>
          </div>
          <div
            style={{
              backgroundColor: "rgb(255, 255, 255)",
              padding: "2em",
              boxShadow: "rgba(0, 0, 0, 0.15) 0px 4px 8px",
              fontFamily: "Lato",
              width: "100%"
            }}
          >
            {page}
          </div>
        </div>
      </div>
    );
  }
}

export default AuditTrail;



// WEBPACK FOOTER //
// ./src/components/audit-trail/page.js